import React, { useRef, useEffect, useState } from 'react';
import { IconButton } from '@material-ui/core';
import FilterListIcon from '@material-ui/icons/FilterList';
import { searchItems, searchValues, claimsDropdown, denialSearchItems, denailFilterDropdown, noRespFilterDropdown, noRespSearchItems } from './data';
import PropTypes from 'prop-types';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import calendar from '../../assets/icons/foot-calendar.svg';
import MaskedInput from 'react-text-mask';
import './footer.css';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import { RoCheckbox } from 'layouts/Form/Checkbox';
import { OutsideAlerter } from '../../global/helpers/index';
import Loader from 'react-loader-spinner';

const autoCorrectedDatePipe = createAutoCorrectedDatePipe('mm/dd/yyyy HH:MM');

const styles = {
  background: 'linear-gradient(0deg, #24476A 31.25%, #8EAFC2 299.25%)',
  height: 70,
  width: '100%',
  position: 'fixed',
  bottom: 0
}

const inputStyle = {
  marginTop: 13,
  marginLeft: 13,
  float: 'left',
  height: 30,
  width: 270,
  borderRadius: '10px'
}

const Footer = (props) => {
  let user = JSON.parse(sessionStorage.getItem("userDetail"));
  const filterRef = useRef(null); // bug 05
  const iconButtonRef = useRef(null);
  const claimsDropdownRef = useRef(null);
  const claimsInputRef = useRef(null); // Reference the input/label area that toggles it
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  // Custom hook for outside click detection
  const useOutsideClick = (ref, iconRef, callback) => {
    useEffect(() => {
      function handleClickOutside(event) {
        if (
          ref.current &&
          !ref.current.contains(event.target) &&
          iconRef.current &&
          !iconRef.current.contains(event.target)
        ) {
          callback();
        }
      }

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref, iconRef, callback]);
  };

  const handleSelectToggle = (event) => {
    event.stopPropagation();
    setIsFilterOpen(prev => !prev);
    props.selectHandler(!isFilterOpen);
  };

  const handleFilterTable = () => {
    props.filterTable();
    setIsFilterOpen(false);
    props.selectHandler(false);
  };

  const handleClearFilter = () => {
    props.clearFilter();
    setIsFilterOpen(false);
    props.selectHandler(false);
  };

  useOutsideClick(filterRef, iconButtonRef, () => {
    if (isFilterOpen) {
      setIsFilterOpen(false);
      props.selectHandler(false);
    }
  });

  useOutsideClick(claimsDropdownRef, claimsInputRef, props.closeClaimsDropdown);

  let path = window.location.pathname;

  const onDateChange = (event) => {
    const e = {
      target: {
        value: 'ranByDay'
      }
    }
    props.handleClaimsDropdown(e)
    props.onDateChange(event)
  }

  const handleClaimsDropdown = async (e) => {
    await props.handleClaimsDropdown(e)
  }

  const updatedSearchItems = [
    { key: 'assignedTo', value: 'Assigned To', data: 'AssignedTo' }, // New start object
    ...searchItems,
    { key: 'whatsNeeded', value: 'What needed', data: 'WhatsNeeded' } // New end object
  ];

  // console.log(props?.whatsNeeded,"///////////", props?.selectValue,"///////////////", props?.checkboxValues)

  // logic to change date format
  // let x = document.querySelector('#inputDate');
  // let formattedDate;
  // if(x){
  //   x.addEventListener('change', function() {
  //     formattedDate = moment(this.value, "YYYY-MM-DD").format(this.getAttribute('data-date-format'));
  //     this.setAttribute('data-date',
  //       moment(this.value, "YYYY-MM-DD").format(this.getAttribute('data-date-format')))
  //       // console.log(this.value, formattedDate);
  //   })
  //   x.dispatchEvent(new Event("change"));
  // }
  // console.log(props.claimSelector, user?.roleId)
  return (
    <div style={styles}>
      {(path === '/rule-processor') && (
        <div className="row">
          <div className="col-6 pt-2">
            <div className="form-inline">
              <div className='footer-left-area'>
                <div className='t-left'>
                  {/* <select 
                className={props.optionSelector === true ? 'sticky-selection2 show-selector' : 'sticky-selection2 none-selector'} 
                onChange={props.onSelectChange} multiple>
                  {searchItems.map((item, key) => (<>
                    <option className='p-1 option text-center font-face-futura-footer' key={key} value={item.key}>{item.value}</option>
                    </>))}
                </select> */}
                  {/* <div className={props.optionSelector === true ? 'sticky-selection2 show-selector' : 'sticky-selection2 none-selector'}> */}
                  <div ref={filterRef} className={isFilterOpen ? 'sticky-selection2 show-selector' : 'sticky-selection2 none-selector'}>
                    <div className='row filter-row'>
                      <div className='col-12 col-sm-12 col-lg-12 filter-txt'>
                        <span className='mx-1 text-light'>Select Filter</span>
                      </div>
                      {/* <div className='col-6 col-sm-6 col-lg-6 text-end filter-txt'>
                        <span className='mx-1'>Clear Filter</span>
                      </div> */}
                    </div>
                    <select
                      className='sticky-sel font-face-futura'
                      value={props.selectValue}
                      onChange={props.onSelectChange}>
                      <option value="" disabled selected>Select</option>
                      {props?.claimsDropdownSelect != "notRan" && <option key="assignedTo" value="assignedTo">Assigned To</option>}
                      {searchItems.map((item, key) => (
                        <>
                          <option style={{ fontSize: 14 }} key={key} value={item.key} id={item.value}>{item.value}</option>
                        </>))}
                      {props?.claimsDropdownSelect != "notRan" && <option key="whatsNeeded" value="whatsNeeded">Whats Needed</option>}
                    </select>
                    <div className={props.showSearch || props.showCheckedValues ? 'mt-2 fil-box2' : 'mt-2 fil-box'}>
                      {props.apiLoading ?
                        <Loader
                          className="apiLoad"
                          type="TailSpin"
                          color="#10496a"
                          height={50}
                          width={50}
                        /> :
                        props.showSearch ?
                          <>
                            <input
                              className='m-2 fil-input font-face-futura'
                              placeholder='Type something to search...'
                              value={props.filterValue}
                              onChange={(e) => props.searchFilterValues(e.target.value)} />
                            <div className={props?.columnData?.length > 0 ? 'fil-drop2' : 'fil-drop'}>
                              {props?.columnData?.length > 0 && props?.columnData?.map((col, idx) => {
                                // console.log(col)
                                return (
                                  <div key={idx} className="fil-opt">
                                    <RoCheckbox
                                      style={{ width: 18, height: 18 }}
                                      value={(props.selectValue == "assignedTo" || props.selectValue == "whatsNeeded") ? col.id : col}
                                      checked={(props.selectValue == "assignedTo" || props.selectValue == "whatsNeeded") ? props.checkboxValues.map(String).includes(String(col.id)) : props.checkboxValues.includes(col)}
                                      onChange={props.handleCheckbox} />
                                    <span className='fil-txt font-face-futura'>{(props.selectValue == "assignedTo" || props.selectValue == "whatsNeeded") ? col.full_name : col}</span>
                                  </div>
                                )
                              })}
                            </div>
                          </> : props.showCheckedValues ?
                            <>
                              <div className='mt-2 mx-2 font-face-futura fil-drop2'>
                                {/* {props.filteredValues.length > 0 && props.filteredValues.map((val, idx) => (
                                <>
                                  <h6 className='text-capitalize'>{val.title}</h6>
                                  <div className="bottom"></div>
                                  {val.values.length > 0 && val.values.map((item, idx) => (
                                    <div key={idx} className="fil-opt">
                                      <RoCheckbox
                                        style={{ width: 18, height: 18 }}
                                        value={item}
                                        checked={val.values.includes(item)}
                                        onChange={props.handleCheckbox} />
                                      <span className='fil-txt font-face-futura'>{item}</span>
                                    </div>
                                  ))}
                                </>
                              ))} */}
                                {Object.keys(props?.filteredValues)?.length > 0 && Object.keys(props?.filteredValues).map((val, idx) => (
                                  props?.filteredValues[val].length > 0 && (<>
                                    <h6 className='text-capitalize'>{(props.claimsDropdownSelect != 'notRan' ? updatedSearchItems : searchItems).find(item => item.data == val)?.value}</h6>
                                    <div className="bottom"></div>
                                    {props?.filteredValues[val]?.map((item, idx) => {
                                      let name;
                                      switch (val) {
                                        case "AssignedTo":
                                          name =  item == "unassigned" ? "Unassigned" : props?.assignedTo.find(as => as.id == item)?.full_name ? props?.assignedTo.find(as => as.id == item)?.full_name : null
                                          break;
                                        case "WhatsNeeded":
                                          name =  item == "unassigned" ? "Unassigned" : props?.whatsNeeded.find(wh => wh.key == item)?.value
                                          break;
                                        default:
                                          name = item
                                          break;
                                      }
                                      return (
                                        <div key={idx} className="fil-opt">
                                          <RoCheckbox
                                            style={{ width: 18, height: 18 }}
                                            value={item}
                                            checked={props?.filteredValues[val]?.includes(item)}
                                            onChange={() => props.handleGobackCheckbox(val, item)} />
                                          <span className='fil-txt font-face-futura'>{name}</span>
                                        </div>
                                      )
                                    })}
                                  </>)
                                ))}
                              </div>
                            </> :
                            <div className='place-txt'><span>Select value to filter the table</span></div>
                      }
                    </div>
                    <div className='row'>
                      {props.showCheckedValues ?
                        <>
                          <div className='col-6 col-sm-6 col-lg-6 goBack' onClick={handleClearFilter}>
                            <span>Clear Filter</span>
                          </div>
                          <div className='col-6 col-sm-6 col-lg-6 goBack' onClick={handleFilterTable}>
                            <span>Apply</span>
                          </div>
                        </> :
                        props.showSearch ?
                          <>
                            <div className='col-6 col-sm-6 col-lg-6 goBack' onClick={props.handleGoBack}>
                              <span>Go Back</span>
                            </div>
                            <div className='col-6 col-sm-6 col-lg-6 goBack' onClick={handleFilterTable}>
                              <span>Apply</span>
                            </div>
                          </> : <></>
                      }
                    </div>
                  </div>
                  <div className='filter-icon'>
                    {/* <IconButton onClick={props.selectHandler}> */}
                    <IconButton ref={iconButtonRef} onClick={handleSelectToggle}>
                      <FilterListIcon
                        style={{ backgroundColor: 'white', width: 32, height: 30, borderRadius: '50%', color: '#535353', marginTop: 1 }} />
                    </IconButton>
                    {(props?.checkboxValues?.length > 0 || props.showCheckedValues) && <p onClick={handleClearFilter}>Clear Filter</p>}
                  </div>
                </div>

                <div className='claimDiv position-relative'>
                  <span className='text-light font-face-futura-footer'>Status: </span>
                  <select ref={claimsDropdownRef} className={(props.claimSelector === true && user?.roleId !== 9) ? 'sticky-select show-selector' : 'sticky-select none-selector'}
                    onChange={props.onClaimChange} multiple>
                    {claimsDropdown.map((claim, key) => (
                      <option
                        className='p-2 option text-center font-face-futura-footer'
                        selected={props.claimsDropdownSelect === claim.key ? true : false}
                        onClick={handleClaimsDropdown} key={key} value={claim.key}>{claim.value}</option>
                    ))}
                  </select>
                  <div onClick={props.claimHandler} ref={claimsInputRef}>
                    <label htmlFor='claims-input' className='claimsDrop'>
                      <input className='claimInput font-face-futura-placeholder'
                        type='text'
                        placeholder={props.labelValue ? props.labelValue : props.claimsDropdownSelect == "claimsNotReviewed" ? "Worklist" : 'Run Encounters'} />
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {props.claimsDropdownSelect == "claimsReviewed" && <div className="col-6 pt-2 font-face-futura-footer">
            <div className='foot-calendar'>
              <span className='text-light scrubTxt'>Scrubbed On: </span>
              <DatePicker
                className='date-picker'
                format={"MM-dd-yyyy"}
                placeholderText="MM/DD/YYYY"
                open={props.isCalendarOpen}
                onInputClick={props.handleCalendarOpen}
                onCalendarClose={props.handleCalendarClose}
                // selected={path === '/rule-processor' ? props.formattedRuleDate : props.rulesDate}
                selected={path === '/rule-processor' && props.formattedRuleDate}
                onChange={path === '/rule-processor' && props.onDateChange}
                // onChange={path === '/rule-processor' ? (e) => onDateChange(e) : props.handleDateChange}
                // BACKSPACE FIRST TIME FIX ↓
                onChangeRaw={(e) => {
                  if (!e.target) {
                    props.onDateChange(null);     // ← clears immediately on first backspace
                  }
                }}
                customInput={
                  <MaskedInput
                    pipe={autoCorrectedDatePipe}
                    mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
                    guide={true}
                    keepCharPositions={true} />}
                onKeyDown={(e) => {
                  if (e.key === "Backspace") {
                    // If the next backspace will clear the field → call your event immediately
                    props.onDateChange(null);
                  }
                }}
              />

              <span className='mt-1'>
                <img src={calendar} alt='foot-calendar' />
              </span>
            </div>
          </div>}
        </div>)}

      {(path === '/denial-management') && (
        // <div className="row" onClick={props.optionSelector === true && props.handleSelectHandler}>
        <div className="row">
          <div className="col-6 pt-2">
            <div className="form-inline">
              <div className='footer-left-area'>
                <div className='t-left'>
                  <div ref={filterRef} className={isFilterOpen ? 'sticky-selection2 show-selector' : 'sticky-selection2 none-selector'}>
                    <div className='row filter-row'>
                      <div className='col-12 col-sm-12 col-lg-12 filter-txt'>
                        <span className='mx-1 text-light'>Select Filter</span>
                      </div>
                    </div>
                    <select
                      className='sticky-sel font-face-futura'
                      id='select-box'
                      value={props.selectValue}
                      onChange={props.onSelectChange}>
                      <option value="" disabled selected>Select</option>
                      {denialSearchItems.map((item, key) => (
                        <>
                          <option style={{ fontSize: 14 }} key={key} value={item.key} id={item.value}>{item.value}</option>
                        </>))}
                    </select>
                    <div className={props.showSearch || props.showCheckedValues ? 'mt-2 fil-box2' : 'mt-2 fil-box'}>
                      {props.apiLoading ?
                        <Loader
                          className="apiLoad"
                          type="TailSpin"
                          color="#10496a"
                          height={50}
                          width={50}
                        /> :
                        props.showSearch ?
                          <>
                            <input
                              className='m-2 fil-input font-face-futura'
                              placeholder='Type something to search...'
                              value={props.filterValue}
                              onChange={(e) => props.searchFilterValues(e.target.value)} />
                            <div className={props?.columnData?.length > 0 ? 'fil-drop2' : 'fil-drop'}>
                              {props?.columnData?.length > 0 && props?.columnData?.map((col, idx) => (
                                <div key={idx} className="fil-opt">
                                  <RoCheckbox
                                    style={{ width: 18, height: 18 }}
                                    value={col}
                                    checked={props?.checkboxValues?.includes(col)}
                                    onChange={props.handleCheckbox} />
                                  <span className='fil-txt font-face-futura'>{col}</span>
                                </div>
                              ))}
                            </div>
                          </> : props.showCheckedValues ?
                            <>
                              <div className='mt-2 mx-2 font-face-futura fil-drop2'>
                                {Object.keys(props?.filteredValues)?.length > 0 && Object.keys(props?.filteredValues).map((val, idx) => (
                                  props?.filteredValues[val].length > 0 && (<>
                                    <h6 className='text-capitalize'>{denialSearchItems.find(item => item.data == val)?.value}</h6>
                                    <div className="bottom"></div>
                                    {props?.filteredValues[val].map((item, idx) => (
                                      <div key={idx} className="fil-opt">
                                        <RoCheckbox
                                          style={{ width: 18, height: 18 }}
                                          value={item}
                                          checked={props?.filteredValues[val].includes(item)}
                                          onChange={() => props.handleGobackCheckbox(val, item)} />
                                        <span className='fil-txt font-face-futura'>{item}</span>
                                      </div>
                                    ))}
                                  </>)
                                ))}
                              </div>
                            </> :
                            <div className='place-txt'><span>Select value to filter the table</span></div>
                      }
                    </div>
                    <div className='row'>
                      {props.showCheckedValues ?
                        <>
                          <div className='col-6 col-sm-6 col-lg-6 goBack' onClick={handleClearFilter}>
                            <span>Clear Filter</span>
                          </div>
                          <div className='col-6 col-sm-6 col-lg-6 goBack' onClick={handleFilterTable}>
                            <span>Apply</span>
                          </div>
                        </> :
                        props.showSearch ?
                          <>
                            <div className='col-6 col-sm-6 col-lg-6 goBack' onClick={props.handleGoBack}>
                              <span>Go Back</span>
                            </div>
                            <div className='col-6 col-sm-6 col-lg-6 goBack' onClick={handleFilterTable}>
                              <span>Apply</span>
                            </div>
                          </> : <></>
                      }
                    </div>
                  </div>
                  <div className='filter-icon'>
                    <IconButton ref={iconButtonRef} onClick={handleSelectToggle}>
                      <FilterListIcon
                        style={{ backgroundColor: 'white', width: 32, height: 30, borderRadius: '50%', color: '#535353', marginTop: 1 }} />
                    </IconButton>
                    {(props?.checkboxValues?.length > 0 || props.showCheckedValues) && <p onClick={handleClearFilter}>Clear Filter</p>}
                  </div>
                </div>
                <OutsideAlerter handleHideState={props.setClaimSelector}>
                  <div className='claimDiv'>
                    <span className='text-light font-face-futura-footer'>Status: </span>
                    <select style={{ height: '111px' }} className={(props.claimSelector === true && user?.roleId != 9) ? 'sticky-select show-selector select-noimage' : 'sticky-select none-selector select-noimage'}
                      onChange={props.onClaimChange} multiple>
                      {denailFilterDropdown.map((claim, key) => (
                        <option
                          className='p-2 option text-center font-face-futura-footer'
                          selected={props.claimsDropdownSelect === claim.key ? true : false}
                          onClick={handleClaimsDropdown} key={key} value={claim.key}>{claim.value}</option>
                      ))}
                    </select>
                    <div onClick={props.statusDropdownHandler}>
                      <label htmlFor='claims-input' className='claimsDrop'>
                        <input className='claimInput font-face-futura-placeholder'
                          type='text'
                          placeholder={props.labelValue ? props.labelValue : 'Claim Center - Not Ran'} />
                      </label>
                    </div>
                  </div>
                </OutsideAlerter>
              </div>
            </div>

            {/* <div className='foot-calendar'>
              <DatePicker
                className='date-picker'
                format={"MM-dd-yyyy"}
                placeholderText="MM/DD/YYYY"
                selected={path === '/rule-processor' ? props.formattedRuleDate : props.rulesDate}
                onChange={path === '/rule-processor' ? (e) => onDateChange(e) : props.handleDateChange}
                customInput={
                  <MaskedInput
                    pipe={autoCorrectedDatePipe}
                    mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
                    guide={true}
                    keepCharPositions={true} />}
              />
              <span className='mt-1 mx-2'>
                <img src={calendar} alt='foot-calendar' />
              </span>
            </div> */}
          </div>

          <div className="col-6 pt-2">
            <div className='foot-calendar font-face-futura'>
              {props.labelValue === "Work List" && <div className='denDivFrom'>
                <span className='text-light denFromTxt'>Denial From: </span>
                <DatePicker
                  className='date-picker'
                  format={"MM-dd-yyyy"}
                  placeholderText="MM/DD/YYYY"
                  selected={path === '/rule-processor' ? props.formattedRuleDate : props.denailFromAndToDate?.fromDate ? new Date(props.denailFromAndToDate?.fromDate) : null}
                  onChange={path === '/rule-processor' ? (e) => onDateChange(e) : (e) => props.handleDateChange(e, 'DENIAL_FROM')}
                  customInput={
                    <MaskedInput
                      pipe={autoCorrectedDatePipe}
                      mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
                      guide={true}
                      keepCharPositions={true} />}
                />
              </div>}
              <div className='denDivTo'>
                <span className='text-light denToTxt'>Denial To: </span>
                <DatePicker
                  className='date-picker'
                  format={"MM-dd-yyyy"}
                  placeholderText="MM/DD/YYYY"
                  selected={path === '/rule-processor' ? props.formattedRuleDate : props.denailFromAndToDate?.toDate ? new Date(props.denailFromAndToDate?.toDate) : null}
                  onChange={path === '/rule-processor' ? (e) => onDateChange(e) : (e) => props.handleDateChange(e, 'DENIAL_TO')}
                  customInput={
                    <MaskedInput
                      pipe={autoCorrectedDatePipe}
                      mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
                      guide={true}
                      keepCharPositions={true} />}
                />
              </div>
              <span className='mt-1 mx-2'>
                <img src={calendar} alt='foot-calendar' />
              </span>
            </div>
          </div>
        </div>)}

      {(path === '/noresponse-management') && (
        // <div className="row" onClick={props.optionSelector === true && props.handleSelectHandler}>
        <div className="row">
          <div className="col-6 pt-2">
            <div className="form-inline">
              <div className='footer-left-area'>
                <div className='t-left'>
                  <div ref={filterRef} className={isFilterOpen ? 'sticky-selection2 show-selector' : 'sticky-selection2 none-selector'}>
                    <div className='row filter-row'>
                      <div className='col-12 col-sm-12 col-lg-12 filter-txt'>
                        <span className='mx-1 text-light'>Select Filter</span>
                      </div>
                    </div>
                    <select
                      className='sticky-sel font-face-futura'
                      id='select-box'
                      value={props.selectValue}
                      onChange={props.onSelectChange}>
                      <option value="" disabled selected>Select</option>
                      {noRespSearchItems.map((item, key) => (
                        <>
                          <option style={{ fontSize: 14 }} key={key} value={item.key} id={item.value}>{item.value}</option>
                        </>))}
                    </select>
                    <div className={props.showSearch || props.showCheckedValues ? 'mt-2 fil-box2' : 'mt-2 fil-box'}>
                      {props.apiLoading ?
                        <Loader
                          className="apiLoad"
                          type="TailSpin"
                          color="#10496a"
                          height={50}
                          width={50}
                        /> :
                        props.showSearch ?
                          <>
                            <input
                              className='m-2 fil-input font-face-futura'
                              placeholder='Type something to search...'
                              value={props.filterValue}
                              onChange={(e) => props.searchFilterValues(e.target.value)} />
                            <div className={props?.columnData?.length > 0 ? 'fil-drop2' : 'fil-drop'}>
                              {props?.columnData?.length > 0 && props?.columnData?.map((col, idx) => (
                                <div key={idx} className="fil-opt">
                                  <RoCheckbox
                                    style={{ width: 18, height: 18 }}
                                    value={col}
                                    checked={props?.checkboxValues?.includes(col)}
                                    onChange={props.handleCheckbox} />
                                  <span className='fil-txt font-face-futura'>{col}</span>
                                </div>
                              ))}
                            </div>
                          </> : props.showCheckedValues ?
                            <>
                              <div className='mt-2 mx-2 font-face-futura fil-drop2'>
                                {Object.keys(props?.filteredValues)?.length > 0 && Object.keys(props?.filteredValues).map((val, idx) => (
                                  props?.filteredValues[val].length > 0 && (<>
                                    <h6 className='text-capitalize'>{denialSearchItems.find(item => item.data == val)?.value}</h6>
                                    <div className="bottom"></div>
                                    {props?.filteredValues[val].map((item, idx) => (
                                      <div key={idx} className="fil-opt">
                                        <RoCheckbox
                                          style={{ width: 18, height: 18 }}
                                          value={item}
                                          checked={props?.filteredValues[val].includes(item)}
                                          onChange={() => props.handleGobackCheckbox(val, item)} />
                                        <span className='fil-txt font-face-futura'>{item}</span>
                                      </div>
                                    ))}
                                  </>)
                                ))}
                              </div>
                            </> :
                            <div className='place-txt'><span>Select value to filter the table</span></div>
                      }
                    </div>
                    <div className='row'>
                      {props.showCheckedValues ?
                        <>
                          <div className='col-6 col-sm-6 col-lg-6 goBack' onClick={handleClearFilter}>
                            <span>Clear Filter</span>
                          </div>
                          <div className='col-6 col-sm-6 col-lg-6 goBack' onClick={handleFilterTable}>
                            <span>Apply</span>
                          </div>
                        </> :
                        props.showSearch ?
                          <>
                            <div className='col-6 col-sm-6 col-lg-6 goBack' onClick={props.handleGoBack}>
                              <span>Go Back</span>
                            </div>
                            <div className='col-6 col-sm-6 col-lg-6 goBack' onClick={handleFilterTable}>
                              <span>Apply</span>
                            </div>
                          </> : <></>
                      }
                    </div>
                  </div>
                  <div className='filter-icon'>
                    <IconButton ref={iconButtonRef} onClick={handleSelectToggle}>
                      <FilterListIcon
                        style={{ backgroundColor: 'white', width: 32, height: 30, borderRadius: '50%', color: '#535353', marginTop: 1 }} />
                    </IconButton>
                    {(props?.checkboxValues?.length > 0 || props.showCheckedValues) && <p onClick={handleClearFilter}>Clear Filter</p>}
                  </div>
                </div>
                <OutsideAlerter handleHideState={props.setClaimSelector}>
                  <div className='claimDiv'>
                    <span className='text-light font-face-futura-footer'>Status: </span>
                    <select style={{ height: '111px' }} className={(props.claimSelector === true && user?.roleId != 9) ? 'sticky-select show-selector select-noimage' : 'sticky-select none-selector select-noimage'}
                      onChange={props.onClaimChange} multiple>
                      {noRespFilterDropdown.map((claim, key) => (
                        <option
                          className='p-2 option text-center font-face-futura-footer'
                          selected={props.claimsDropdownSelect === claim.key ? true : false}
                          onClick={handleClaimsDropdown} key={key} value={claim.key}>{claim.value}</option>
                      ))}
                    </select>
                    <div onClick={props.statusDropdownHandler}>
                      <label htmlFor='claims-input' className='claimsDrop'>
                        <input className='claimInput font-face-futura-placeholder'
                          type='text'
                          placeholder={props.labelValue ? props.labelValue : 'Claim Center - Not Ran'} />
                      </label>
                    </div>
                  </div>
                </OutsideAlerter>
              </div>
            </div>

            {/* <div className='foot-calendar'>
        <DatePicker
          className='date-picker'
          format={"MM-dd-yyyy"}
          placeholderText="MM/DD/YYYY"
          selected={path === '/rule-processor' ? props.formattedRuleDate : props.rulesDate}
          onChange={path === '/rule-processor' ? (e) => onDateChange(e) : props.handleDateChange}
          customInput={
            <MaskedInput
              pipe={autoCorrectedDatePipe}
              mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
              guide={true}
              keepCharPositions={true} />}
        />
        <span className='mt-1 mx-2'>
          <img src={calendar} alt='foot-calendar' />
        </span>
      </div> */}
          </div>

          <div className="col-6 pt-2">
            <div className='foot-calendar font-face-futura'>
              {props.labelValue === "Work List" && <div className='denDivFrom'>
                <span className='text-light denFromTxt'>No Resp From: </span>
                <DatePicker
                  className='date-picker'
                  format={"MM-dd-yyyy"}
                  placeholderText="MM/DD/YYYY"
                  selected={path === '/rule-processor' ? props.formattedRuleDate : props.denailFromAndToDate?.fromDate ? new Date(props.denailFromAndToDate?.fromDate) : null}
                  onChange={path === '/rule-processor' ? (e) => onDateChange(e) : (e) => props.handleDateChange(e, 'DENIAL_FROM')}
                  customInput={
                    <MaskedInput
                      pipe={autoCorrectedDatePipe}
                      mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
                      guide={true}
                      keepCharPositions={true} />}
                />
              </div>}
              <div className='denDivTo'>
                <span className='text-light denToTxt'>No Resp To: </span>
                <DatePicker
                  className='date-picker'
                  format={"MM-dd-yyyy"}
                  placeholderText="MM/DD/YYYY"
                  selected={path === '/rule-processor' ? props.formattedRuleDate : props.denailFromAndToDate?.toDate ? new Date(props.denailFromAndToDate?.toDate) : null}
                  onChange={path === '/rule-processor' ? (e) => onDateChange(e) : (e) => props.handleDateChange(e, 'DENIAL_TO')}
                  customInput={
                    <MaskedInput
                      pipe={autoCorrectedDatePipe}
                      mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
                      guide={true}
                      keepCharPositions={true} />}
                />
              </div>
              <span className='mt-1 mx-2'>
                <img src={calendar} alt='foot-calendar' />
              </span>
            </div>
          </div>
        </div>)}

      {path.includes('/manageRule') && (
        <div className="row">
          <div className="col-6 pt-2">
            <div className="form-inline">
              <div className='footer-left-area'>
                <div className='t-left'>
                  <select
                    className={props.selector === true ? 'sticky-selection show-selector' : 'sticky-selection none-selector'}
                    onChange={props.onSelect} multiple>
                    {searchValues.map((item, key) => (<>
                      <option className='p-1 option text-center font-face-futura-footer' key={key} value={item.key}>{item.value}</option>
                    </>))}
                  </select>
                  <IconButton onClick={props.clickHandler}>
                    <FilterListIcon
                      style={{ backgroundColor: 'white', width: 32, height: 30, borderRadius: '50%', color: '#535353', marginTop: 3 }} />
                  </IconButton>
                </div>
                <div>
                  <input
                    type="text"
                    className='p-2 searchInput font-face-futura-placeholder'
                    placeholder={props.placeholder ? props.placeholder : 'Search by rule name'}
                    style={inputStyle}
                    value={props.ruleSearchValue}
                    onChange={props.onInput}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>)}

      {path === '/create-rule' && (<></>)}
    </div>
  );
}

Footer.propTypes = {
  onSelectChange: PropTypes.func.isRequired,
  searchValue: PropTypes.string.isRequired,
  onInputChange: PropTypes.func.isRequired,
  rulesRan: PropTypes.bool.isRequired,
  ruleSuccess: PropTypes.bool.isRequired,
  formattedRuleDate: PropTypes.string.isRequired,
  rulesDate: PropTypes.string.isRequired,
  onDateChange: PropTypes.func.isRequired,
  handleDateChange: PropTypes.func.isRequired,
  selector: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
  clickHandler: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  ruleSearchValue: PropTypes.string.isRequired,
  onInput: PropTypes.func.isRequired,
  handleClaimsDropdown: PropTypes.func.isRequired
}

export default Footer;
